import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AlliesRoutingModule } from './allies-routing.module';
import { AlliesComponent } from './components/allies/allies.component';
import { SwiperModule } from 'swiper/angular';
import { ConfirmDialog, ConfirmDialogModule } from 'primeng/confirmdialog';
import { LibTbModalNotificationModule, LibTbButtonModule } from 'tech-block-lib';
import { KeyFilterModule } from 'primeng/keyfilter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { SharedModule } from '@modules/shared.module';

@NgModule({
  declarations: [
    AlliesComponent
  ],
  imports: [
    CommonModule,
    AlliesRoutingModule,
    SwiperModule,
    ConfirmDialogModule,
    LibTbModalNotificationModule,
    KeyFilterModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    CheckboxModule,
    ButtonModule,
    LibTbButtonModule,
    SharedModule
  ],
  providers: [
    ConfirmDialog
  ]
})
export class AlliesModule { }
